export const DEFAULT_DEBOUNCE_TIMEOUT_MS = 50;
